import {
    Component,
    Inject,
    ViewChild,
    OnInit,
    OnDestroy,
    AfterViewInit,
    ElementRef,
    HostListener,
} from '@angular/core';
import { Title } from '@angular/platform-browser';

import { StorageService } from './lib/storage.service';
import { AuthService } from './lib/auth.service';
import { ApiService } from './lib/api.service';
import { User } from './models/user';

import { LogService } from './lib/log.service';
import { ModalService } from './lib/modal.service';
import {
    Router,
    ActivatedRoute,
    NavigationEnd,
    Event,
    Params,
} from '@angular/router';

import { Angulartics2 } from 'angulartics2';
import { Angulartics2GoogleAnalytics } from 'angulartics2';
import { ApiError } from './lib/api-error';

import { TranslateService } from '@ngx-translate/core';
import { AutoLogoutService } from './lib/auto-logout';
import { AutoLogoutIdle } from './lib/auto-logout-idle';
import { BehaviorSubject, Subscription } from 'rxjs';
import {
    HttpClient,
    HttpResponse,
    HttpHeaders,
    HttpErrorResponse,
} from '@angular/common/http';
import jQuery from 'jquery';
import { MessagingService } from './lib/message-service';
import amplitude from 'amplitude-js';
import { environment } from 'environments/environment';
import { AnalyticEvent } from './lib/analytic-event';
import { UserService } from './lib/user.service';
@Component({
    templateUrl: 'app.component.html',
    selector: 'app',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class WellTrackBoostApp implements OnInit, OnDestroy {
    rootPage: any; // = TabsPage;
    user: User;
    popup: any;
    queryLang: any;
    onLangChange: Subscription = undefined;
    message: any;
    pushShown: boolean = false;
    constructor(
        private storage: StorageService,
        private auth: AuthService,
        private api: ApiService,
        private log: LogService,
        private modalService: ModalService,
        private router: Router,
        private angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics,
        private translateService: TranslateService,
        private activatedRoute: ActivatedRoute,
        private autologout: AutoLogoutService,
        private autologoutIdle: AutoLogoutIdle,
        public el: ElementRef,
        titleService: Title,
        private http: HttpClient,
        private messagingService: MessagingService,
        private userService: UserService
    ) {
        var instance1 = amplitude
            .getInstance()
            .init(environment.amplitude.api_key);
        this.autologoutIdle.initialize();
        // this language will be used as a fallback when a translation isn't found in the current language
        this.translateService.setDefaultLang('en');
        let lang = <string>this.storage.get('lang', false);

        if (lang) {
            this.translateService.use(lang);
        } else {
            if (this.translateService.getBrowserLang() === 'fr') {
                this.translateService.use('fr');
                lang = 'fr';
            } else if (this.translateService.getBrowserLang() === 'es') {
                this.translateService.use('es');
                lang = 'es';
            } else {
                this.translateService.use('en');
                lang = 'en';
            }
            this.storage.set('lang', lang, false);
        }

        //Listen for changes to authenticated state
        this.auth.Authenticator.subscribe((authenticated: boolean) => {
            if (authenticated) {
                this.checkForAuthentication();
            }
        });

        router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.log.debug('event navigation called');
                let titles = this.translateService
                    .get('pagetitles')
                    .subscribe(res => {
                        this.log.debug(res);
                        var title = this.getTitle(
                            router.routerState,
                            router.routerState.root
                        ).join('-');
                        let translatedTitle = res[title]
                            ? res[title]
                            : 'Welltrack';
                        titleService.setTitle(translatedTitle);
                    });
            }
        });

        // Foreground push notification — fired when a message arrives
        // while the app tab is open.
        this.messagingService.currentMessage.subscribe(message => {
            this.pushShown = false;
            this.message = message;
            this.pushShown = true;
        });

        this.checkForAuthentication();
    }

    closePush() {
        this.pushShown = false;
    }

    ngOnInit() {
        this.updateLanguage();
        this.onLangChange = this.translateService.onLangChange.subscribe(() => {
            this.updateLanguage();
        });
        this.activatedRoute.queryParams.subscribe((params: Params) => {
            this.queryLang = params['lang'];
            if (this.queryLang === 'fr') {
                this.storage.set('lang', this.queryLang, false);
                this.translateService.use('fr');
            }
        });
        this.translateService.stream('error').subscribe((res: any) => {
            this.popup = res;
        });
        //Is this the first time running the app?
        if (!this.storage.checkFlag('first_app_run')) {
            this.storage.setFlag('first_app_run');
            this.log.event(AnalyticEvent.event.appInstalled);
        }

        this.javascriptFixes();
    }

    javascriptFixes() {
        jQuery(document).keydown(function (event) {
            if (
                (navigator.userAgent.indexOf('Safari') > -1 &&
                    navigator.userAgent.indexOf('Chrome') == -1) ||
                navigator.userAgent.indexOf('Firefox') > -1 ||
                true
            ) {
                if (event.which === 9) {
                    if (!event.shiftKey) {
                        var selectables = jQuery(
                            'a, input, select, textarea, button, iframe, object, embed, *[tabindex], *[contenteditable]'
                        ).not('[tabindex=-1], [disabled], :hidden');
                        var current = jQuery(':focus');
                        var nextIndex = 0;
                        if (current.length === 1) {
                            var currentIndex = selectables.index(current);
                            if (currentIndex + 1 < selectables.length) {
                                nextIndex = currentIndex + 1;
                            }
                        }
                        selectables.eq(nextIndex).focus();
                    } else {
                        var selectables = jQuery(
                            'a, input, select, textarea, button, iframe, object, embed, *[tabindex], *[contenteditable]'
                        ).not('[tabindex=-1], [disabled], :hidden');
                        var current = jQuery(':focus');
                        var prevIndex = selectables.length - 1;
                        if (current.length === 1) {
                            var currentIndex = selectables.index(current);
                            if (currentIndex > 0) {
                                prevIndex = currentIndex - 1;
                            }
                        }
                        selectables.eq(prevIndex).focus();
                    }
                    event.preventDefault();
                }
            }
        });
    }

    handleDocumentKeyDown() {}

    getTitle(state, parent) {
        var data = [];
        if (parent && parent.snapshot.data && parent.snapshot.data.title) {
            data.push(parent.snapshot.data.title);
        }

        if (state && parent) {
            data.push(...this.getTitle(state, state.firstChild(parent)));
        }
        return data;
    }

    ngOnDestroy() {
        if (this.onLangChange !== undefined) {
            this.onLangChange.unsubscribe();
        }
    }

    checkForAuthentication() {
        let resp = this.auth.isAuthenticated();

        if (resp) {
            this.api.get('users/me').subscribe(
                (result: any) => {
                    this.log.debug(result.data);
                    this.user = new User(result.data);
                    this.log.user(this.user.id.toString());
                    this.log.organization(
                        this.user.primaryOrganization
                            ? this.user.primaryOrganization.id.toString()
                            : ''
                    );
                    //store in local
                    this.storage.set('user', this.user, true);

                    if (this.user.userType === 'admin') {
                        this.storage.set('isAuthenticated', true, false, 200);
                    }
                },
                (error: ApiError) => {
                    this.log.error(
                        'Error fetching user profile: ' + error.message
                    );

                    if (error.status === 401) {
                        this.auth.logout();
                    } else {
                        this.modalService.showAlert(
                            this.popup.title,
                            this.popup.connect
                        );
                    }
                },
                () => {
                    //has the user entered an access code yet?
                    if (this.user.userType !== 'admin') {
                        //this.autologout.initialize();
                    }

                    if (this.user.userType === 'user') {
                        if (
                            !this.storage.checkFlag(
                                'finished-tutorial-welcome'
                            ) ||
                            this.user.onboardingStep < 3
                        ) {
                            if (
                                this.userService.isShowTutorialPage(this.user)
                            ) {
                                this.router.navigateByUrl('user-onboarding');
                            } else {
                                this.navigateToRedirectUrlForEndUser();
                            }
                        } else {
                            this.navigateToRedirectUrlForEndUser();
                        }
                    }

                    if (this.auth.redirectUrl && this.user.userType != 'user') {
                        this.router.navigateByUrl(this.auth.redirectUrl);
                        this.auth.redirectUrl = null;
                    } else {
                        if (
                            this.router.url === 'login' &&
                            this.user.userType != 'user'
                        ) {
                            this.router.navigate(['app']);
                        }
                    }
                }
            );
        }
    }

    navigateToRedirectUrlForEndUser() {
        if (this.auth.redirectUrl) {
            this.router.navigateByUrl(this.auth.redirectUrl);
            this.auth.redirectUrl = null;
        } else {
            if (this.router.url === 'login') {
                this.router.navigate(['app']);
            }
        }
    }

    updateLanguage() {
        const lang = document.createAttribute('lang');
        lang.value = this.translateService.currentLang;
        this.el.nativeElement.parentElement.parentElement.attributes.setNamedItem(
            lang
        );
    }
}
